import { FC } from "react";
// import { UseTranslationContext } from "../Context/TranslationContext";
import MUITooltipCustom from "./MUITooltipCustom";
import { FormattedValue } from "../hooks/dataFormatter";

export type ResultComponentModel = 'SINGLE_LINE_VALUE' | 'SINGLE_LINE_VALUE_TOTAL' | 'SINGLE_LINE';

interface SalarySimResultProps {
    modelType: ResultComponentModel;
    modelText: string;
    modelValue: number;
    modelTooltip?: string;
    modelTooltipAlt?: string;
    modelTooltipPlacement?: string;
}

const ResultElementComponent: FC<SalarySimResultProps> = (props) => {

    // const{getKeyFromKeyId} = UseTranslationContext();

    const getElementValue=()=>{


        if((props.modelValue!=null || props.modelValue!=undefined || !isNaN(props.modelValue)))
        {
            try{
                return(FormattedValue(props.modelValue));
            }
            catch(e){
                return 0;
            }
        }
    }
    
    const GenerateComponent = () => {
        switch (props.modelType) {
            case "SINGLE_LINE_VALUE": 
                return(
                    <div className="row">
                        {/* <p className="detail">{getKeyFromKeyId(props.modelText)}</p> */}
                        <p className="detail">
                            {props.modelText}
                            {props.modelTooltip && props.modelTooltipAlt &&
                                <MUITooltipCustom tooltipText={props.modelTooltip} buttonAltText={props.modelTooltipAlt} placement={props.modelTooltipPlacement||"left"}/>
                            }
                        </p>
                        <p className="sum">{getElementValue() }</p>
                    </div>
                );
            break;
            case "SINGLE_LINE_VALUE_TOTAL": 
                return(
                    <div className="row total">
                        {/* <p className="detail total">{getKeyFromKeyId(props.modelText)}</p> */}
                        <p className="detail total">
                            {props.modelText}
                            {props.modelTooltip && props.modelTooltipAlt &&
                                <MUITooltipCustom tooltipText={props.modelTooltip} buttonAltText={props.modelTooltipAlt} placement={props.modelTooltipPlacement||"left"}/>
                            }
                        </p>
                        
                        <p className="sum total">{getElementValue() }</p>
                    </div>
                );
                break;
            case "SINGLE_LINE": 
                return(
                    <div className="row">
                        {/* <p className="detail">{getKeyFromKeyId(props.modelText)}</p> */}
                        <p className="detail">
                            {props.modelText}
                            {props.modelTooltip && props.modelTooltipAlt &&
                                <MUITooltipCustom tooltipText={props.modelTooltip} buttonAltText={props.modelTooltipAlt} placement={props.modelTooltipPlacement||"left"}/>
                            }
                        </p>
                    </div>
                );
            break;
            default: 
                return (<></>);
            break;
        }
    }

    return (
        <>
            {GenerateComponent()}
        </>
    );
}

export default ResultElementComponent;